const indianStates = [
  "andhra_pradesh",
  "arunachal_pradesh",
  "assam",
  "bihar",
  "chhattisgarh",
  "goa",
  "gujarat",
  "haryana",
  "himachal_pradesh",
  "jharkhand",
  "karnataka",
  "kerala",
  "madhya_pradesh",
  "maharashtra",
  "manipur",
  "meghalaya",
  "mizoram",
  "nagaland",
  "odisha",
  "punjab",
  "rajasthan",
  "sikkim",
  "tamil_nadu",
  "telangana",
  "tripura",
  "uttar_pradesh",
  "uttarakhand",
  "west_bengal",
  "andaman_and_nicobar_islands",
  "chandigarh",
  "dadra_and_nagar_haveli_and_daman_and_diu",
  "delhi",
  "jammu_and_kashmir",
  "ladakh",
  "lakshadweep",
  "puducherry",
];

export default indianStates;
